import Vue from 'vue';
import Router from 'vue-router';

import login from '@/views/login';
import Home from '@/views/Home';
import NotFound from '@/views/NotFound'
import system_menu from '@/views/system/menu';
import system_staff from '@/views/system/staff';
import system_help from '@/views/system/help';
import system_about from '@/views/system/about';
import system_advertising from '@/views/system/advertising';
// import system_news from '@/views/system/news';
import data_area from '@/views/data/area';
import data_massif from '@/views/data/massif';
import data_parameter from '@/views/data/parameter';
import data_parameter_info from '@/views/data/parameter_info';
import list_index_pinzhou from '@/views/list/index_pinzhou';
import list_index_youxi from '@/views/list/index_youxi';
import list_index_qita from '@/views/list/index_qita';
import list_fixed from '@/views/list/fixed';
import list_news from '@/views/list/news';
import list_info from '@/views/list/info';


Vue.use(Router);
var routes=[
	{
		path: '/login',
		name: 'login',
		component: login
	},{
		path: '/404',
		name: 'NotFound',
		component: NotFound
	},
	{
		path: '/',
		name: '',
		component: Home,
		children: [
			{
				path: 'system_menu',
				component: system_menu,
				name: '系统设置'
			},
			{
				path: 'system_staff',
				component: system_staff,
				name: '员工管理'
			},
			{
				path: 'system_help',
				component: system_help,
				name: '使用帮助'
			},
			{
				path: 'system_about',
				component: system_about,
				name: '关于我们'
			},
			{
				path: 'system_advertising',
				component: system_advertising,
				name: '广告管理'
			},
		],
	},
	{
		path: '/',
		name: '数据字典',
		component: Home,
		children: [
			{
				path: 'data_area',
				component: data_area,
				name: '地块管理'
			},
			{
				path: 'data_massif',
				component: data_massif,
				name: '片区管理'
			},
			{
				path: 'data_parameter',
				component: data_parameter,
				name: '参数管理'
			},
			{
				path: 'data_parameter_info',
				component: data_parameter_info,
				name: '参数管理小项'
			},
		]
	},
	{
		path: '/',
		name: '数据管理',
		component: Home,
		children: [
			{
				path: 'list_index',
				component: list_index_pinzhou,
				name: '种质资源'
			},
			{
				path: 'list_index_youxi',
				component: list_index_youxi,
				name: '种质资源1'
			},
			{
				path: 'list_index_qita',
				component: list_index_qita,
				name: '种质资源2'
			},
			{
				path: 'list_info',
				component: list_info,
				name: '种质资源详情'
			},
			{
				path: 'list_news',
				component: list_news,
				name: '资讯管理'
			},
			{
				path: 'list_fixed',
				component: list_fixed,
				name: '固定资产管理'
			},
		]
	},
	
];

export default routes;




// WEBPACK FOOTER //
// ./src/router/index.js